import { Component, Input, Output, OnChanges, EventEmitter, OnInit, ElementRef, Renderer2 } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { DropdownPrompt } from '../../../../../forms/models'
import { IQuestionAnswer } from '../..'
import { QuestionViewService } from '../../question-view.service'

@Component({
  selector: 'mp-dropdown-choice-view',
  templateUrl: './dropdown-choice-view.html',
  styleUrls: ['./dropdown-question-view.scss']
})
export class DropdownChoiceViewComponent implements OnChanges, OnInit {
  @Input() public answerChoicePrompt: DropdownPrompt
  @Input() public formGroup: FormGroup

  @Output() public optionSelected: EventEmitter<IQuestionAnswer> = new EventEmitter()

  public choiceText: string =""
  public reviewMode: boolean = false

  public constructor(
    private el: ElementRef,
    private _questionViewService: QuestionViewService,
    private _renderer: Renderer2
  ) {}


  public ngOnInit() {
    this.renderDropdownContainer()
    this.renderDropdown()
  }

  public ngOnChanges() {
    this.reviewMode = this._questionViewService.reviewMode
  }

  public selectOption(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value
    if (this.reviewMode || this.formGroup.disabled) {
      //Reset the value. This has to be done in jQuery so the element registers the change
      $(event.target).val(this.formGroup.value.answerChoice)
      return
    }

    this.formGroup.setValue({answerChoice: selectedValue})
    this.optionSelected.emit({choiceId: selectedValue, value: ''})
  }

  private renderDropdownContainer(){
    this.choiceText= this.answerChoicePrompt.label.replace("[DROPDOWN]", `<span id=${this.answerChoicePrompt.key}></span>`)
    const dropdownContainer = this.el.nativeElement.querySelector('.dropdown-container')
    dropdownContainer.innerHTML = this.choiceText
  }

  private renderDropdown(){
    this.answerChoicePrompt.options.subscribe((options)=>{
      let correctAnswerValue = ''
      const className = this._questionViewService.question.isAnswerChoiceCorrect(this.answerChoicePrompt.value) ? 'correct' : 'incorrect'
      const choiceSelect = this._renderer.createElement('select')
      const defaultOption = this._renderer.createElement('option')
      this._renderer.setAttribute(choiceSelect, 'formControlName', this.answerChoicePrompt.key)
      this._renderer.addClass(choiceSelect, className)
      this._renderer.setProperty(defaultOption, 'innerHTML', '')
      this._renderer.appendChild(choiceSelect, defaultOption)
      this._renderer.listen(choiceSelect, 'change', (event) => {
        this.selectOption(event)
      })

      options.forEach(option => {
        const optionElement = this._renderer.createElement('option')
        this._renderer.setProperty(optionElement, 'value', option.value)
        if (option.value === this.answerChoicePrompt.value){
          this._renderer.setAttribute(optionElement, 'selected', 'selected')
        }

        this._renderer.setProperty(optionElement, 'innerHTML', option.label)
        this._renderer.appendChild(choiceSelect, optionElement)

        if(this._questionViewService.question.isAnswerChoiceCorrect(option.value)){
          correctAnswerValue = option.label
        }
      })

      const choiceSpan = this.el.nativeElement.querySelector(`#${this.answerChoicePrompt.key}`)
      this._renderer.appendChild(choiceSpan,choiceSelect )
      this.renderCorrectAnswer(choiceSpan, correctAnswerValue)
    })
  }

  private renderCorrectAnswer(choiceSpan, correctAnswerValue){
    if(this.reviewMode && !(this._questionViewService.question.isAnswerChoiceCorrect(this.answerChoicePrompt.value))){
      const correctAnswerBox = this._renderer.createElement('span')
      this._renderer.addClass(correctAnswerBox, 'correct')
      this._renderer.addClass(correctAnswerBox, 'dropdown-correct')
      this._renderer.setProperty(correctAnswerBox, 'innerHTML', correctAnswerValue)
      this._renderer.appendChild(choiceSpan, correctAnswerBox)
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/dropdown-choice-view/dropdown-choice-view.component.ts